<template>
<div class="chapter">
<div class="inner_page">
<p class="halftitle1" id="ch00_fm06_halftitle1"><a id="page_xi"></a>T.D. Jakes<a id="page_xii"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm06_halftitle1.vue?12c04d00